module.exports = new __parcel__URL__("preview-bg.12045916.svg").toString();